import { useEffect, useState } from "react";
import { TextField, TextFieldProps } from "@mui/material";

export type ManagedTextFieldProps = TextFieldProps & {
	value: string;
	onUpdate: (value: string) => void;
};

const ManagedTextField: React.FC<ManagedTextFieldProps> = (
	props: ManagedTextFieldProps
) => {
	const [value, setValue] = useState(props.value);

	useEffect(() => setValue(props.value), [props.value]);

	function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
		if (e.key === "Enter") {
			e.preventDefault();
			const element = e.target as HTMLInputElement;
			const value = element.value.trim();
			setValue(value);
			if (value !== props.value) {
				props.onUpdate(value);
			}
		}
	}

	function handleBlur(e: React.FocusEvent<HTMLInputElement>): void {
		const value = e.target.value.trim();
		setValue(value);
		if (value !== props.value) {
			props.onUpdate(value);
		}
	}

	return (
		<TextField
			autoFocus={props.autoFocus}
			value={value}
			label={props.label}
			disabled={props.disabled}
			error={props.error}
			fullWidth={props.fullWidth}
			type={props.type}
			variant={props.variant}
			multiline={props.multiline}
			minRows={props.minRows}
			InputProps={props.InputProps}
			onKeyDown={handleKeyDown}
			onBlur={handleBlur}
			onChange={e => setValue(e.target.value)}
		/>
	);
};

export default ManagedTextField;
